import clsx from 'clsx'

const DAYS_IN_WEEK = 7

/** Cells draw exposed edges; neighbouring cells already draw shared edges. */
export default function getCalendarCellBorderClassName(cellIndex: number, firstCellColumn: number): string {
  const gridPosition = firstCellColumn - 1 + cellIndex
  const column = gridPosition % DAYS_IN_WEEK + 1

  return clsx({
    'border-inline-start': cellIndex === 0 || column === 1,
    // The first seven rendered cells have no cell above them.
    'border-block-start': cellIndex < DAYS_IN_WEEK,
  })
}
